export default __webpack_public_path__ + "static/media/comment.8e935d0d.svg";